// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/crm/leads/css/activity.css
// module id = 4702
// module chunks = 0